<header class="mobile-header">
  <div class="header-content">
    <div class="header-toggle">
      @if (canGoBack()) {
        <button mat-icon-button (click)="goBack()" aria-label="Volver" class="back-button">
          <mat-icon class="material-symbols-rounded outline">arrow_back_ios</mat-icon>
        </button>
      } @else {
        <button mat-icon-button [matMenuTriggerFor]="userMenu" aria-label="Menú de usuario" class="menu-button">
          <mat-icon class="material-symbols-rounded outline">dehaze</mat-icon>
        </button>
        <mat-menu #userMenu="matMenu">
          <button mat-menu-item (click)="personalInformation()">
            <mat-icon class="material-symbols-rounded outline">person</mat-icon>
            <span>{{ 'auth.buttons.personalInformation' | translate }}</span>
          </button>
          <button mat-menu-item (click)="changePassword()">
            <mat-icon class="material-symbols-rounded outline">lock</mat-icon>
            <span>{{ 'auth.buttons.changePassword' | translate }}</span>
          </button>
          <button mat-menu-item (click)="logout()">
            <mat-icon class="material-symbols-rounded outline">logout</mat-icon>
            <span>{{ 'auth.buttons.logout' | translate }}</span>
          </button>
        </mat-menu>
      }
    </div>

    <div class="header-title">
      @if (isInHomeView()) {
        <img src="https://munily-public-cdn.s3.us-east-1.amazonaws.com/faceRecognition/customized/Autodromo/autodromoLogoHorizontal.svg" alt="Autodromo" class="logo">
      } @else {
        <h5 class="app-title">{{ getPageTitle() }}</h5>
      }
    </div>

    <!-- Botón de crear - Home (filled style) -->
    @if (showFilledCreateButton()) {
      <div class="header-action">
        <button mat-raised-button color="primary" (click)="createInvitation()" class="create-button button-text">
          {{ 'invitation.titles.createInvitation' | translate }}
          <mat-icon class="material-symbols-rounded outline icon-right">add</mat-icon>
        </button>
      </div>
    }

    <!-- Botón de crear - Invitations/Entries (outline style) -->
    @if (showOutlineButton()) {
      <div class="header-action">
        <button mat-stroked-button (click)="createInvitation()" class="create-button-outline button-text">
          {{ 'invitation.titles.createInvitation' | translate }}
          <mat-icon class="material-symbols-rounded outline icon-right">add</mat-icon>
        </button>
      </div>
    }

    <!-- Menú de opciones - Solo en vista de detalles -->
    @if (isInDetailsView()) {
      <div class="header-action">
        <button mat-icon-button [matMenuTriggerFor]="detailsMenu" aria-label="Opciones" class="options-button">
          <mat-icon class="material-symbols-rounded outline">more_vert</mat-icon>
        </button>
        <mat-menu #detailsMenu="matMenu">
          <button mat-menu-item (click)="shareInvitation()">
            <mat-icon class="material-symbols-rounded outline">share</mat-icon>
            <span>{{ 'invitation.buttons.shareInvitation' | translate }}</span>
          </button>
          <button mat-menu-item (click)="deleteInvitation()">
            <mat-icon class="material-symbols-rounded outline">delete</mat-icon>
            <span>{{ 'invitation.buttons.deleteInvitation' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    }
  </div>
</header>